import { styled } from "."

export const TitleCenter = styled("h4")({
  textAlign: "center",
  fontWeight: 600,
  fontSize: 20,
})
